<ion-content class="change-password modal-outher-container">
  <ion-grid
    class="modal-inner-container modal-inner-container--no-transform change-password__grid"
  >
    <ion-row>
      <ion-col>
        <app-modal-header
          [header]="translate.instant('SETTINGS.CHANGE_PASSWORD')"
          (close)="back()"
        ></app-modal-header>
        <form [formGroup]="form" (ngSubmit)="onSubmit()">
          <app-input
            type="password"
            [form]="form"
            formControlName="oldPassword"
            label="SETTINGS.OLD_PASSWORD"
            [submittedError]="validationError"
          ></app-input>

          <app-input
            type="password"
            [form]="form"
            formControlName="newPassword"
            label="RESET_PASSWORD.NEW_PASSWORD"
            [submittedError]="validationError"
          ></app-input>

          <app-input
            type="password"
            [form]="form"
            formControlName="newPasswordAgain"
            label="RESET_PASSWORD.REPEAT_NEW_PASSWORD"
            [submittedError]="validationError"
          ></app-input>

          <ion-label
            *ngIf="
              form.get('newPassword').touched &&
              form.get('newPasswordAgain').touched &&
              form.hasError('notSamePasswords')
            "
            color="danger"
            class="font-size__16"
          >
            {{ 'RESET_PASSWORD.NOT_SAME_PASSWORDS' | translate }}
          </ion-label>
          <ion-label *ngIf="showErrorText" color="danger" class="font-size__16">
            {{ 'SETTINGS.OLD_PASSWORD_INCORRECT' | translate }}
          </ion-label>
          <ion-button
            type="submit"
            size="medium"
            class="change-password__submit-button"
            [disabled]="disableSaveButton"
          >
            <ng-container *ngIf="!disableSaveButton">{{
              'SAVE' | translate
            }}</ng-container>
            <ng-container *ngIf="disableSaveButton">{{
              'SAVING' | translate
            }}</ng-container>
          </ion-button>
        </form>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
